import MainPageLayout from 'components/Organization/MainPageLayout';
import React, { FC } from 'react';

import SuperAdminOpportunitiesListContentNew from 'components/Organization/Opportunities/SuperAdminOpportunitiesNew/SuperAdminOpportunitiesListContentNew';

// styles
import styles from '../SuperAdminOppoList/SuperAdminOppoList.module.scss';

const SuperAdminOppoListNew: FC = () => {
	return (
		<MainPageLayout>
			<div className={styles.container}>
				<div className={styles.block_title}>
					<h1 className="title">Opportunities List</h1>
					<SuperAdminOpportunitiesListContentNew />
				</div>
			</div>
		</MainPageLayout>
	);
};

export default SuperAdminOppoListNew;
